var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cakeBw from "assets/img/token-bw/cake-bw.png";
import quantaBw from "assets/img/token-bw/quanta-bw.png";
import usdtBw from "assets/img/token-bw/usdt-bw.png";
import styled from "styled-components";
// Декоративный фон админки (по макету Background-слоя):
// «чертёжная» сетка 120px + золотые/синие радиальные свечения + приглушённые
// ч/б логотипы токенов вотермарком. Лежит позади контента, не ловит клики.
var Layer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  inset: 0;\n  z-index: 0;\n  pointer-events: none;\n  overflow: hidden;\n"], ["\n  position: fixed;\n  inset: 0;\n  z-index: 0;\n  pointer-events: none;\n  overflow: hidden;\n"])));
var Grid = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  inset: 0;\n  background-image: linear-gradient(to right, rgba(255, 255, 255, 0.04) 1px, transparent 1px),\n    linear-gradient(to bottom, rgba(255, 255, 255, 0.04) 1px, transparent 1px);\n  background-size: 120px 120px;\n"], ["\n  position: absolute;\n  inset: 0;\n  background-image: linear-gradient(to right, rgba(255, 255, 255, 0.04) 1px, transparent 1px),\n    linear-gradient(to bottom, rgba(255, 255, 255, 0.04) 1px, transparent 1px);\n  background-size: 120px 120px;\n"])));
var Orb = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  width: ", "px;\n  height: ", "px;\n  border-radius: 50%;\n  background: radial-gradient(circle, ", " 0%, rgba(0, 0, 0, 0) 70%);\n"], ["\n  position: absolute;\n  width: ", "px;\n  height: ", "px;\n  border-radius: 50%;\n  background: radial-gradient(circle, ", " 0%, rgba(0, 0, 0, 0) 70%);\n"])), function (_a) {
    var $size = _a.$size;
    return $size;
}, function (_a) {
    var $size = _a.$size;
    return $size;
}, function (_a) {
    var $color = _a.$color;
    return $color;
});
var Watermark = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  width: ", "px;\n  height: ", "px;\n  object-fit: contain;\n"], ["\n  position: absolute;\n  width: ", "px;\n  height: ", "px;\n  object-fit: contain;\n"])), function (_a) {
    var $size = _a.$size;
    return $size;
}, function (_a) {
    var $size = _a.$size;
    return $size;
});
// BNB / TWT — векторами (их ч/б PNG имеют непрозрачный фон и плохо смотрятся
// на тёмном; рисуем path как в макете, fill #E6E6EC, без фона).
var VECTOR_MARKS = [
    {
        d: "M38.73 53.2l24.26-24.26 24.28 24.28 14.11-14.12-38.39-38.39-38.38 38.38z m-38.03 10.11l14.11-14.11 14.11 14.11-14.11 14.11z m38.03 10.1l24.26 24.26 24.27-24.27 14.12 14.1-38.39 38.4-38.38-38.38z m58.96-10.1l14.11-14.11 14.11 14.1-14.11 14.12z m-20.3-0.01l-14.4-14.4-10.64 10.64-1.22 1.22-2.52 2.52 14.38 14.4z",
        viewBox: "0 0 126.61 126.61",
        size: 50,
        style: { top: 60, right: "8%", opacity: 0.22 },
    },
    {
        d: "M50 6l40 16 0 34c0 30-18 46-40 52-22-6-40-22-40-52l0-34z",
        viewBox: "0 0 100 112",
        size: 46,
        style: { bottom: 175, left: "31%", opacity: 0.22 },
    },
];
var PNG_MARKS = [
    { src: quantaBw, size: 56, style: { top: 32, left: "40%", opacity: 0.26 } },
    { src: usdtBw, size: 54, style: { top: "60%", right: "9%", opacity: 0.24 } },
    { src: cakeBw, size: 56, style: { bottom: 150, left: "47%", opacity: 0.24 } },
];
export var AdminBackground = function () { return (_jsxs(Layer, { "aria-hidden": true, children: [_jsx(Grid, {}), _jsx(Orb, { "$color": "rgba(255,184,1,0.22)", "$size": 740, style: { top: -220, right: -80 } }), _jsx(Orb, { "$color": "rgba(255,184,1,0.16)", "$size": 620, style: { bottom: -140, right: 160 } }), _jsx(Orb, { "$color": "rgba(59,130,246,0.16)", "$size": 640, style: { bottom: -80, left: 220 } }), PNG_MARKS.map(function (w, i) { return (_jsx(Watermark, { src: w.src, "$size": w.size, style: w.style, alt: "" }, "png-".concat(i))); }), VECTOR_MARKS.map(function (m, i) { return (_jsx("svg", { width: m.size, height: m.size, viewBox: m.viewBox, style: __assign({ position: "absolute" }, m.style), "aria-hidden": true, children: _jsx("path", { d: m.d, fill: "#E6E6EC" }) }, "vec-".concat(i))); })] })); };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
